import { PapiroConsole } from '../utils/papiroConsole';
import Api from './api';

export const getAllApiPermissionPolicies = async () => { 
  let data = [];
  await Api.get('/apipermissionpolicy/getall')
      .then(result => {
          data = result.data
       })
       .catch(err => {
          data = err;
  });
  return data;
};

